/** Tempo médio de aprovação: da criação da conciliação até a aprovação (conciliações APROVADAS com datas válidas). */
export const tempoMedioAprovacaoHoras = (
  conciliacoes: { status: string; criadoEm?: string | null; atualizadoEm?: string | null }[],
): number | null => {
  const duracoes = conciliacoes
    .filter(c => c.status === 'APROVADA' && c.criadoEm && c.atualizadoEm)
    .map(c => (new Date(c.atualizadoEm as string).getTime() - new Date(c.criadoEm as string).getTime()) / 3_600_000)
    .filter(h => Number.isFinite(h) && h >= 0);
  if (duracoes.length === 0) return null;
  return duracoes.reduce((s, h) => s + h, 0) / duracoes.length;
};

/** "—" sem dados; menos de 24h em horas; a partir disso em dias com uma casa decimal. */
export const formatarDuracao = (horas: number | null): string => {
  if (horas == null) return '—';
  if (horas < 1) return 'menos de 1h';
  if (horas < 24) return `${Math.round(horas)}h`;
  return `${(horas / 24).toFixed(1).replace('.', ',')} dias`;
};
